import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/app/services/Helper/helper.service';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { User } from 'src/app/models/ui/User';
import { UserService } from 'src/app/services/user.service';
import { ProviderParameters, BankDetailParameters } from 'src/app/models/ui/ProviderParameters';
import { RegistrationService } from 'src/app/services/registration.service';

@Component({
  selector: 'app-provider-information',
  templateUrl: './provider-information.component.html',
  styleUrls: ['./provider-information.component.css']
})
export class ProviderInformationComponent implements OnInit {

  constructor(private helper: HelperService, private registrationService: RegistrationService, private lookup: LookupService) { 
    this.userToUpdate = new User();
    this.providerDetails = new ProviderParameters();
    this.bankDetailParameters = new BankDetailParameters();
  }

  isAuthorized: string;

  loadingVisible = false;

  userRegex: any;
  emailRegex: any;
  phoneRegex: any;

  isValid: boolean;

  countries: any[];

  userToUpdate: User;
  providerDetails: ProviderParameters;
  bankDetailParameters: BankDetailParameters;

  ngOnInit() {
    this.isAuthorized = localStorage.getItem("isAuthorized");

    this.lookup.getProvider().subscribe(data => this.processProvider(data));
    this.lookup.getCountries().subscribe(data => this.countries = data);

    if(this.isAuthorized === "true") {
      this.helper.setTitle('Provider - Provider Info');
    }
    else
      location.assign("#/login-form");
  }

  processProvider(data) {
    this.providerDetails = data;
    this.lookup.getBankDetails(data.BankDetailsId).subscribe(data => this.bankDetailParameters=data);
  }

  submitChanges(e) {
      this.loadingVisible = true;
      this.registrationService.updateProvider(this.providerDetails).subscribe(data => this.displayResult(data));
  }

  submitBankChanges(e) {
    this.loadingVisible = true;
    this.registrationService.updateBankInfo(this.bankDetailParameters).subscribe(data => this.displayResult(data));
  }

  displayResult(data) {
    this.loadingVisible = false;
    alert(data);
    setTimeout(() => {
      location.reload();
    }, 2000);
  }
}